module.exports = {
  development: {
    baseUrl: "/dev-api",
    mockUrl: "https://xxxx",
  },
  production: {
    baseUrl: "https://xxxx",
    mockUrl: "https://xxxx",
  },
};
